/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import CourseEmailPreferencesList from 'bundles/account-settings/components/sections/email-preferences/CourseEmailPreferencesList';
import type { CourseEmailPreference, UpdateStatus } from 'bundles/account-settings/types/EmailPreferences';

import _t from 'i18n!nls/account-settings';

type Props = {
  disabled: boolean;
  coursePreferences: CourseEmailPreference[];
  updateStatus: UpdateStatus;
};

const styles = {
  title: css`
    margin-block-end: var(--cds-spacing-100);
  `,
  supportText: css`
    margin-block-end: var(--cds-spacing-200);
  `,
};

const CourseEmailPreferences = ({ disabled, coursePreferences, updateStatus }: Props) => (
  <div>
    <Typography2 component="h2" variant="subtitleMedium" css={styles.title}>
      {_t('Course communications')}
    </Typography2>
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.supportText}>
      {_t(
        `Toggle and customize alerts for relevant announcements, reminders, or discussion forums activity for courses you're enrolled in.`
      )}
    </Typography2>
    <CourseEmailPreferencesList disabled={disabled} coursePreferences={coursePreferences} updateStatus={updateStatus} />
  </div>
);

export default CourseEmailPreferences;
